import { createValidation } from "helpers/validation/createValidation";
import { CompanyRegisterFormValues } from "./types";

export const FIELD_LABEL_PROPS = {
  variant: "body16rg" as const,
  sx: {
    color: "base.500",
    fontWeight: 600,
    mb: 0.5,
  },
};

export const SELECT_FIELD_SX = {
  backgroundColor: "bgSwitch",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "divider",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "divider",
  },
};

export const STEP_TITLES = ["Реквизиты", "Руководитель", "Команда"] as const;

export const KPP_RULES = createValidation({
  pattern: {
    value: /^[0-9]{9}$/,
    message: "Должно быть 9 цифр",
  },
});

export const OGRN_RULES = createValidation({
  pattern: {
    value: /^[0-9]{13}$/,
    message: "Должно быть 13 цифр",
  },
});

export const OKPO_RULES = createValidation({
  pattern: {
    value: /^(?:[0-9]{8}|[0-9]{10}|[0-9]{14})$/,
    message: "Должно быть 8, 10 или 14 цифр",
  },
});

export const OKATO_RULES = createValidation({
  pattern: {
    value: /^[0-9]{2,11}$/,
    message: "Должно быть от 2 до 11 цифр",
  },
});

export const OKTMO_RULES = createValidation({
  pattern: {
    value: /^(?:[0-9]{8}|[0-9]{11})$/,
    message: "Должно быть 8 или 11 цифр",
  },
});

export const FALLBACK_MANAGER_POSITION = "Руководитель";
export const FALLBACK_USER_POSITION = "Руководитель";

export const DEFAULT_COMPANY_REGISTER_VALUES: CompanyRegisterFormValues = {
  inn: "",
  fullName: "",
  contractNumber: "",
  shortName: "",
  kpp: "",
  ogrn: "",
  ogrnDate: undefined,
  type: null,
  managerFio: "",
  managerPosition: "",
  okpo: "",
  okato: "",
  oktmo: "",
  registrationAddress: "",
  registrationDate: undefined,
  state: null,
  userPosition: "",
  agreement: true,
  leaderFullName: "",
  isCompanyLeader: true,
  teamEmail: "",
  teamMembers: [],
  teamPosition: "",
  teamRole: "",
};
